import fernet from "fernet";
var secret = new fernet.Secret(process.env.REACT_APP_KEY_DECODE);

function decodeData(response_data) {
    try {
        var data = new fernet.Token({
        secret: secret,
        token: response_data,
        ttl: 0
        }).decode()
        return JSON.parse(data)
    } catch(error) {
        console.log("Loi decode", error);
    }
}

export { decodeData };